// extracted by mini-css-extract-plugin
export default {"flexVertical":"ftOkPhXVIsUb-06DPZPzW","flexHorizontal":"_3PR9oyJdscR8HsxnN4XmHu","labelHeader":"_28gH3z9BDj1F7BP_kTgSIO","labelDesc":"_1giHf1F8WBQWti1HEq2Apq"};